import logo from "../images/ibeam_logo.svg";
import shape from "../images/shape.svg";

const Authorization = () => {
  return (
    <div className="auth-shell-brand bg-blue p-6 md:p-10 flex flex-col justify-between relative">
      <div>
        <img src={logo} alt="logo" className="w-32 md:w-40" />
      </div>
      <div className="mt-auto mb-8">
        <h2 className="text-white text-3xl md:text-4xl font-bold mb-4">
          Welcome to the Intelligent Documentation Agent
        </h2>
        <p className="text-white text-base md:text-lg">
          Turning complex systems into clear, comprehensive documentation-efficiently, reliably, and at scale.
        </p>
      </div>
      <div className="absolute bottom-0 right-0 hidden md:block">
        <img src={shape} alt="curve" className="w-[260px] h-[95px] object-contain" />
      </div>
    </div>
  );
};

export default Authorization;
